import React from 'react';
import PlannerWrapper from 'containers/Planner/Main/Loadable';
import { PageTrackerWrapper } from 'queries/user/track';
import { PreviewPlannerPDFData } from 'containers/Planner/Main/Calendar/PreviewPDF';
import PlannerCalendar from 'containers/Planner/Main/Calendar/Loadable';
import PreviewCategoriesPlannerPDF from 'containers/Planner/Main/Categories/PreviewPDF/Loadable';
import Category from 'containers/Planner/Main/Categories/Category/Loadable';
import CategoriesList from 'containers/Planner/Main/Categories/Loadable';
import { Navigate } from 'react-router-dom';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';

export const PlannerRoutes = {
  path: 'planner',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.planner.title" />
      <PlannerWrapper />
    </>
  ),
  children: [
    {
      path: 'calendar',
      children: [
        {
          path: 'preview-pdf',
          element: (
            <PageTrackerWrapper title="Planner - calendrier - aperçu PDF">
              <PreviewPlannerPDFData />
            </PageTrackerWrapper>
          ),
        },
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Planner - calendrier">
              <PlannerCalendar />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      path: 'categories',
      children: [
        {
          path: 'preview-pdf',
          element: (
            <PageTrackerWrapper title="Planner - catégories - aperçu PDF">
              <PreviewCategoriesPlannerPDF />
            </PageTrackerWrapper>
          ),
        },
        {
          path: ':categoryId',
          element: (
            <PageTrackerWrapper title="Planner - catégories - détail">
              <Category />
            </PageTrackerWrapper>
          ),
        },
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Planner - catégories - liste">
              <CategoriesList />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      index: true,
      element: <Navigate to="categories" replace />,
    },
  ],
};
